import { Controller } from 'stimulus';
import '@/js/modules/jquery_modal_defaults';

// The modal is looked up by id rather than as a target: jquery-modal moves it out of
// this controller's subtree when it opens.
export default class extends Controller {
  static values = { modalId: String };

  // The client's current team: a link only because the menu primitive renders links.
  ignore(event) {
    event.preventDefault();
  }

  confirmSwitch(event) {
    event.preventDefault();

    const modal = document.getElementById(this.modalIdValue);
    if (!modal) {
      return;
    }

    const { name, url } = event.params;
    modal.querySelector('[data-switch-team-confirm]').setAttribute('href', url);
    modal.querySelector('[data-switch-team-body]').textContent =
      `Switching to ${name} will allow you to access any project(s) you have with this company.`;
    $(modal).modal();
  }
}
